import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors, getSpacing } from '../utils';

const getColor = props => {
  if (props.Color in colors) {
    return colors[props.color];
  }

  if (props.danger) {
    return colors.r01;
  }

  if (props.info) {
    return colors.b01;
  }

  return colors.r03;
};

const getTextColor = props => {
  if (props.textColor in colors) {
    return colors[props.color];
  }

  if (props.danger || props.info) {
    return colors.w01;
  }

  return colors.r01;
};

export const Alert = styled.div`
  background-color: ${props => getColor(props)};
  border: 0 none;
  border-radius: 4px;
  color: ${props => getTextColor(props)};
  display: ${props => (props.error ? 'block' : 'none')};
  font-size: ${props => props.fontSize}px;
  font-weight: ${props => props.fontWeight};
  flex: 1;
  height: 40px;
  line-height: 42px;
  margin: ${props => getSpacing(props.margin)};
  padding: ${props => getSpacing(props.padding)};
  text-align: center;
  width: 100%;
`;

Alert.defaultProps = {
  fontSize: 12,
  fontWeight: 400,
  margin: 'none',
  padding: 'none',
  info: false,
  danger: false
};

Alert.propTypes = {
  fontSize: PropTypes.number,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  info: PropTypes.bool,
  danger: PropTypes.bool
};
